// extracted by mini-css-extract-plugin
export default {"root":"Home_root__4yaCO","wrapper":"Home_wrapper__eKaKG","emptyWrapper":"Home_emptyWrapper__FP+qe","header":"Home_header__LEAKK"};